const projectData = [
  {
    id: 1,
    name: "Ciseco - Modern e-commerce shopping mall",
    websitePerpas: "Product selling website",
    details:
      " is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    images: [
      "https://i.postimg.cc/cCx2vs1L/Capture.png",
      "https://i.postimg.cc/DZKtKrts/Capture2.png",
      "https://i.postimg.cc/G2J63BCf/Capture3.png",
      "https://i.postimg.cc/QM7RP4nh/Capture4.png",
      "https://i.postimg.cc/HxwKBrv2/Capture6.png",
      "https://i.postimg.cc/9M5Kddb0/Capture7.png",
      "https://i.postimg.cc/5yMJtcTP/Capture5.png",
    ],
    technologyUse: [
      "react",
      "typescript",
      "mongoDb",
      "express",
      "node",
      "redux",
      "redux toolkit",
      "jwt",
      "stripe",
      "framer motion",
      "helmet",
      "Matrial UI",
    ],
    clientCode: "https://github.com/sohagzayan/e-commerce-shop",
    serverCode: "https://github.com/sohagzayan/e-commerce-shop",
    liveLink: "https://e-commerce-shop-production.up.railway.app/",
    category: "MERN",
    feature: [
      "There are 2 types of roles - admin, Saller & User",
      "admin can handle all order processing to ship also admin can observe  all user and product ",
      "User can buy product easy way using any international card",
      "Ciseco have a one shop page this page user can filter product using lots of thing",
    ],
  },
  // {
  //   id: 1,
  //   name: "Exclusive Computer Hardware Fair",
  //   websitePerpas: "this is comming sooon",
  //   details:
  //     " is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
  //   images: [
  //     "https://i.postimg.cc/prk8zGf3/cover-project.png",
  //     "https://i.postimg.cc/prk8zGf3/cover-project.png",
  //     "https://i.postimg.cc/1Rw2ZSVm/10.png",
  //   ],
  //   technologyUse: ["react", "node", "mongoDb", "firebase", "node js", "jwt"],
  //   clientCode:
  //     "https://github.com/sohagmia360/exclusive_computer_hardware_fair",
  //   serverCode:
  //     "https://github.com/sohagmia360/exclusive_computer_hardware_fair_sarver_side",
  //   liveLink: "https://assinment-12-6ac8f.web.app/",
  //   category: "MERN",
  //   feature: [
  //     "In the Home Page you can see Navbar, Banner section, Inventory , Our speciality, Our customer review, Available Stock & Footer section",
  //     "Users can create an account and can upload their product', 'Also, users can Delete their Products and make changes to stock update",
  //     "User can add their item in the Add items page & see their added item in the My items page",
  //     "Inside the Blogs page You can see 4 recent blogs available",
  //   ],
  // },
  {
    id: 2,
    name: "SHAPE YOUR IDEAL BODY management",
    websitePerpas: "this is comming sooon",
    details:
      " is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    images: [
      "https://i.postimg.cc/9Qn13wL4/code-2.png",
      "https://i.postimg.cc/R08S2m61/55.png",
      "https://i.postimg.cc/PqNf6Jxr/66.png",
    ],
    technologyUse: ["react", "node", "mongoDb", "firebase", "node js", "jwt"],
    clientCode:
      "https://github.com/sohagmia360/exclusive_computer_hardware_fair",
    liveLink: "https://shape-your-ideal-body.web.app/",
    category: "MERN",
    feature: [
      "In the Home Page you can see Navbar, Banner section, Inventory , Our speciality, Our customer review, Available Stock & Footer section",
      "Users can create an account and can upload their product', 'Also, users can Delete their Products and make changes to stock update",
      "User can add their item in the Add items page & see their added item in the My items page",
      "Inside the Blogs page You can see 4 recent blogs available",
    ],
  },
  {
    id: 3,
    name: "Fresh Grocery Food Shopping",
    websitePerpas: "this is comming sooon",
    details:
      " is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    images: [
      "https://i.postimg.cc/WbSXnHrw/Screenshot-2022-06-08-160044.png",
      "https://i.postimg.cc/KzJdCrs6/98.png",
      "https://i.postimg.cc/7hhp4GFf/99.png",
    ],

    technologyUse: ["react", "node", "mongoDb", "firebase", "node js", "jwt"],
    clientCode: "https://github.com/sohagmia360/warehouse_management_app",
    serverCode: "https://github.com/sohagmia360/warehouse-management-serve",
    liveLink: "https://mern-stack-foodify-shop.vercel.app/",
    category: "MERN",
    feature: [
      "In the Home Page you can see Navbar, Banner section, Inventory , Our speciality, Our customer review, Available Stock & Footer section",
      "Users can create an account and can upload their product', 'Also, users can Delete their Products and make changes to stock update",
      "User can add their item in the Add items page & see their added item in the My items page",
      "Inside the Blogs page You can see 4 recent blogs available",
    ],
  },
  {
    id: 4,
    name: "THE DELIGHT JUMBO BURGER",
    websitePerpas: "this is comming sooon",
    details:
      " is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    images: [
      "https://i.postimg.cc/jqH8W5S9/cover-5.png",
      "https://i.postimg.cc/RF6Db5KH/44.png",
      "https://i.postimg.cc/G3M4xWzQ/97.png",
    ],

    technologyUse: ["react", "node", "mongoDb", "firebase", "node js", "jwt"],
    clientCode:
      "https://github.com/sohagmia360/exclusive_computer_hardware_fair",
    liveLink: "https://preeminent-cupcake-119a2c.netlify.app/",
    category: "MERN",
    feature: [
      "In the Home Page you can see Navbar, Banner section, Inventory , Our speciality, Our customer review, Available Stock & Footer section",
      "Users can create an account and can upload their product', 'Also, users can Delete their Products and make changes to stock update",
      "User can add their item in the Add items page & see their added item in the My items page",
      "Inside the Blogs page You can see 4 recent blogs available",
    ],
  },
  // {
  //   id: 5,
  //   name: "User friendly todo app . this is easy to use",
  //   websitePerpas: "this is comming sooon",
  //   details:
  //     " is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
  //   images: [
  //     "https://i.postimg.cc/k41gw9Jd/cover-7.png",
  //     "https://i.postimg.cc/NfwPjX8Z/cover-image-7.png",
  //     "https://i.postimg.cc/qqgm9c25/88.png",
  //   ],
  //   technologyUse: ["react", "node", "mongoDb", "firebase", "node js", "jwt"],
  //   clientCode:
  //     "https://github.com/sohagmia360/exclusive_computer_hardware_fair",
  //   serverCode:
  //     "https://github.com/sohagmia360/exclusive_computer_hardware_fair_sarver_side",
  //   liveLink: "https://assinment-12-6ac8f.web.app/",
  //   category: "MERN",
  //   feature: [
  //     "In the Home Page you can see Navbar, Banner section, Inventory , Our speciality, Our customer review, Available Stock & Footer section",
  //     "Users can create an account and can upload their product', 'Also, users can Delete their Products and make changes to stock update",
  //     "User can add their item in the Add items page & see their added item in the My items page",
  //     "Inside the Blogs page You can see 4 recent blogs available",
  //   ],
  // },
  {
    id: 6,
    name: "Todo app for store note and others daily task",
    websitePerpas: "this is comming sooon",
    details:
      " is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    images: [
      "https://i.postimg.cc/WpHNJsKJ/six3.jpg",
      "https://i.postimg.cc/gjQG9KRK/six2.jpg",
      "https://i.postimg.cc/QCHjnzBt/six1.jpg",
    ],
    technologyUse: [
      "Next",
      "Node",
      "Express",
      "MongoDB",
      "Redux",
      "Mongoose",
      "Tailwind CSS",
    ],
    clientCode: "https://github.com/sohagzayan/MERN-Stack-todo-application",

    liveLink: "https://full-stack-todo-application.vercel.app/",
    category: "next",
    feature: [
      "is a full Stack todo app . this app purpose user can store every day task ",
      "user can create todo  and also user also user can update status on todo ",
      "and user have a one dashBored all todo semmary details user can see ",
      "also user all todo seperate by todo status and full user friendly",
    ],
  },
  {
    id: 7,
    name: "Todo app for store node and others documents",
    websitePerpas: "this is comming sooon",
    details:
      " is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    images: [
      "https://i.postimg.cc/yYWfTKJt/second1.jpg",
      "https://i.postimg.cc/4y2WTL0W/second2.jpg",
      "https://i.postimg.cc/tRBSPJgF/second3.jpg",
    ],

    technologyUse: ["HTML", "CSS", "Bootstrap"],
    clientCode:
      "https://github.com/Porgramming-Hero-web-course/money-master-sohagmia360",
    serverCode:
      "https://github.com/sohagmia360/exclusive_computer_hardware_fair_sarver_side",
    liveLink: "https://elastic-raman-e5a209.netlify.app/",
    category: "junior",
    feature: [
      " this is static web site ",
      "web site parpus Presentup Convention Center ",
    ],
  },
  {
    id: 7,
    name: "Presentation Convention Center arranger",
    websitePerpas: "this is comming sooon",
    details:
      " is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    images: [
      "https://i.postimg.cc/QM4trcbf/Screenshot-2022-08-23-182546.jpg",
      "https://i.postimg.cc/rm7wDc7W/Screenshot-2022-08-23-182624.jpg",
      "https://i.postimg.cc/NMK0GLCB/Screenshot-2022-08-23-182707.jpg",
    ],
    technologyUse: ["HTML", "CSS", "Bootstrap"],
    clientCode: "https://github.com/sohagzayan/My-Mission-in-2022",
    serverCode:
      "https://github.com/sohagmia360/exclusive_computer_hardware_fair_sarver_side",
    liveLink: "https://competent-mirzakhani-decfde.netlify.app/",
    category: "junior",
    feature: [
      " this is static web site ",
      "web site presentation Convention Center arranger ",
    ],
  },
];

export default projectData;
